var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLocalizationIcon = function SvgLocalizationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#localizationIcon_svg__rz6mdtjz7a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.544 1.57V0h-1v1.57A6.45 6.45 0 001.613 7.5H-.001v1h1.614a6.45 6.45 0 005.931 5.931v1.57h1v-1.57a6.45 6.45 0 005.932-5.93h1.525v-1h-1.525a6.45 6.45 0 00-5.932-5.933zm0 11.862v-1.431h-1v1.431a5.463 5.463 0 01-4.931-4.93H4v-1H2.613A5.463 5.463 0 017.544 2.57V4h1V2.57a5.462 5.462 0 014.931 4.93h-1.474v1h1.474a5.463 5.463 0 01-4.93 4.931z",
    fill: "#222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "localizationIcon_svg__rz6mdtjz7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLocalizationIcon;